module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEiSURBVDhPY/hnnL74f2goMwOl4J9x6sH/5vEKUC754J9xSjIQT4ByyQf/7e1ZgK76AWL/88hl/2+fxUMKBhsCA/+MUq//M0rb9d847T+pGKj34T+LdGmIQYZpMdgUEYv/maTNABsEAtgUEIuBMV8INQYU6GnvsSkihIHh+++faaww1BigQSbpWdgUEsJAg15CjYAAcCxgUUgI/zNJXQ81AgL+M9QzYVNICP/Ty9CBGoEAwHDajE0xPgzVigr+G2fZYFOMCwOjfT9UKyoAGs8IDPRKUExg04iMgVF+8L99PQtUK3YAyir/zHL5cGK9GG6QpVDluMF/0/QEoLO3QrkoAOgS/38mGSuJMggY6PMx0gcUAKO7F5gvHwO9xwoVAgIGBgAK3sLo5TpY8wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/img/7.png
// module id = 86
// module chunks = 0